// API/ ProjectAPI.js

import { api } from "../Component/Configuration/ApiConfig";

const projectApi = {
  getProjectList: async () => {
    try {
      const response = await api.get("/Project/GetProjectList?id=0");
      console.log(response);
      const { status, resultData } = response.data;

      if (status) {
        return resultData;
      } else {
        console.error("Failed to fetch project list");
        return [];
      }
    } catch (error) {
      console.error("Error fetching project list:", error.message);
      return [];
    }
  },

  addUpdateProject: async (values) => {
    try {
      const response = await api.put(`/Project/AddUpdateProject`, values);
      console.log(response);
      const { status, resultData } = response.data;

      if (status) {
        return resultData;
      } else {
        console.error("Failed to update project");
        return null;
      }
    } catch (error) {
      console.error("Error updating project:", error.message);
      return null;
    }
  },

  deleteProject: async (serviceId) => {
    try {
      const response = await api.delete(
        `/Project/DeleteProject?serviceId=${serviceId}`
      );
      console.log(response);
      const { status, resultData } = response.data;

      if (status) {
        return resultData;
      } else {
        console.error("Failed to delete project");
        return [];
      }
    } catch (error) {
      console.error("Error deleting project:", error.message);
      return [];
    }
  },
  GetServiceStatus: () => {
    const request = api.get("Project/GetServiceStatus");
    return request.then((response) => {
      return response.data;
    });
  },
  GetServicesDataForChart: () => {
    const request = api.get("/Customers/GetServiceDataInChart");
    return request.then((response) => {
      return response.data;
    });
  },
  GetServiceCustomerList: (serviceId)=>{
    const request=api.get(`Project/GetServiceCustomerList?serviceId=${serviceId}`)
    return request.then((response)=>{
        return response.data
    })
  },
  GetServiceNameById: (serviceId)=>{
    const request=api.get(`Project/GetServiceNameById?serviceId=${serviceId}`)
    return request.then((response)=>{
        return response.data
    })
  }
};

export default projectApi;
